import React, { useEffect, useState, useRef } from "react";
import ProjectDropdown from "../common/ProjectDropdown";
import { getPeopleByProjects, getPeopleByProject, getPeopleByCompany, clearPeople, getCompanyInvites, sendCompanyInvite, revokeCompanyInvite } from "../../actions/people";
import { getCompany } from "../../actions/company";
import { connect, useSelector } from "react-redux";
import PeopleList from "./PeopleList";
import InvitePersonModal from "./InvitePersonModal";
import IconX from "../iconComponents/IconX";
import {setActiveSidebarPage} from "../../actions/core";
import {Redirect} from "react-router-dom";
import {logout} from "../../actions/auth";

export function People( props ) {

    // GLOBAL STATE --------------------------------------------------------------------------------------------------------------------------
    const peopleInCompany = useSelector( (state) => state.people.peopleInCompany );
    const peopleInProjects = useSelector( (state) => state.people.peopleInProjects );

    const auth = useSelector( (state) => state.auth );
    const ca = useSelector( (state) => state.auth.user.croles["Company Admin"] );
    const project = useSelector( (state) => state.projects.project );
    const company = useSelector( (state) => state.company.company );
    // company.uuid guards against the brief window before getCompany() resolves, where
    // company.is_basic would otherwise be undefined and read as "not Basic"
    const companyLoaded = Boolean(company.uuid);
    const isBasic = companyLoaded && company.is_basic;
    const companyInvites = useSelector( (state) => state.people.companyInvites );

    // LOCAL STATE --------------------------------------------------------------------------------------------------------------------------
    const [currentTab, setCurrentTab] = useState("by_project");
    const [showList, setShowList] = useState(false);
    const [inviteModalOpen, setInviteModalOpen] = useState(false);

    const people =
        currentTab === "by_project"
        ? peopleInProjects
        : peopleInCompany;

    // when component mounts, tab changes, or project is selected, load list of people to global state
    useEffect(() => {
        switch (currentTab) {
            case "by_project":
                project.project_id && project.project_id !== undefined
                ? props.getPeopleByProject(project.project_id)
                : props.getPeopleByProjects();
            break;
            case "by_company":
                props.getPeopleByCompany();
            break;
        }
    }, [project]);

    const isFirstMount = useRef(true);
    useEffect(() => {
        if (isFirstMount.current) {
            isFirstMount.current = false;
        } else {
            setShowList(true);
        }
    }, [people])

    const handleSetTab = (tab) => {
    // when tab is clicked, load new people list. Wait for data to be returned before visibly switching the tab to prevent flash of wrong list
    setShowList(false);
        switch (tab) {
            case "by_project":
                project.project_id !== undefined 
                ? props.getPeopleByProject(project.project_id)
                : props.getPeopleByProjects(); 
            break;
            case "by_company":
                props.getPeopleByCompany();
            break;
        }
        setCurrentTab(tab);
    }


    // When the component unmounts, clear list of people from global state
    useEffect(() => {
        props.setActiveSidebarPage("people");
        props.getCompany();
        ca && props.getCompanyInvites();
        return () => {
            props.clearPeople();
        }
    }, []);

    const handleSendInvite = (email, roles) => {
        props.sendCompanyInvite(email, roles);
        setInviteModalOpen(false);
    }

    const noPeopleMessage =
        currentTab === "by_project" ? "You have no project contacts yet"
            :(currentTab === "by_company" ? "There are no other users in your company yet" : "")

    return (
        <div className={auth ? "page-wrapper" : "flex-column center" }>
            <div className="header-div">
                <div>
                    <div  className="iblock vtop">
                        <h1 className="header title heavy iblock">People </h1>
                    </div>
                    <div className="iblock vtop"> 
                        {currentTab === "by_project" && <ProjectDropdown />}
                    </div>
                </div>
            </div>
            <div>
                <div id="my_projects_people" className="tab">
                    <h2 className={"title2 " + (currentTab === "by_project" ? "heavy" : "heavy-grey")} onClick={() => handleSetTab("by_project")}>
                        My Projects
                    </h2>
                    <div className={currentTab == "by_project" ? "tab-underline" : "tab-underline inactive"}></div>
                </div>
                <div id="my_company_people" className="tab">
                    <h2 className={"title2 " + (currentTab === "by_company" ? "heavy" : "heavy-grey")} onClick={() => handleSetTab("by_company")}>
                        My Company
                    </h2>
                    <div className={currentTab == "by_company" ? "tab-underline" : "tab-underline inactive"}></div>
                </div>
                {ca && companyLoaded && !isBasic &&
                <div id="my_requests_people" className="tab">
                    <h2 className={"title2 " + (currentTab === "by_request" ? "heavy" : "heavy-grey")} onClick={() => handleSetTab("by_request")}>
                        Invites&nbsp;
                        {companyInvites.length > 0 && <span className="alert-count content2 p light" >{companyInvites.length}</span>}
                    </h2>
                    <div className={currentTab == "by_request" ? "tab-underline" : "tab-underline inactive"}></div>
                </div>
                }
            </div>
            {inviteModalOpen &&
                <InvitePersonModal handleClose={() => setInviteModalOpen(false)} onSubmit={handleSendInvite} />
            }
            {currentTab === "by_company" && isBasic
            ? <div className="page-card narrow" style={{whiteSpace: "normal", maxWidth: "560px"}}>
                <h3 className="title2 heavy gap-below-xs">Bring your whole team onto 4-ward.ai</h3>
                <p className="content1 light-black multiline">
                    A Basic account is just you, so there's no company roster to show here yet.
                    Enterprise adds Super Users and Editors, lets you grant teammates Viewer
                    access to specific projects, and gives Company Admins visibility across every
                    contract your company is party to -- not just the ones you personally handle.
                </p>
              </div>
            : currentTab === "by_request"
            ? <div className="gap-below-s settings">
                <div className="subhead-wrapper flex-row space-btwn">
                    <h2 className="title2 heavy iblock gap-right-xs">Invites</h2>
                    {ca &&
                        <button type="button" id="invite_person" className="btn pri iblock mini" onClick={() => setInviteModalOpen(true)}>Invite</button>
                    }
                </div>
                <div className="table-wrapper">
                    <div className="grid">
                        <div className="grid-child" style={{ gridColumn: "span 4" }}>
                            {companyInvites.length > 0
                            ? companyInvites.map(invite => (
                                <div key={invite.uuid} className="flex-row space-btwn gap-below-xxs" style={{alignItems: "center"}}>
                                    <p className="content1 light-black">
                                        {invite.email}
                                        <span className="light-black">
                                            {" -- "}{invite.role_company_admin ? "Super User" : (invite.role_creator ? "Editor" : "No permissions")}
                                        </span>
                                    </p>
                                    <button onClick={() => props.revokeCompanyInvite(invite.uuid)} >
                                        <IconX height="12px" pathClass="g7-fill" />
                                    </button>
                                </div>
                              ))
                            : <h4 className="content1 multiline light">You have no pending invites at this time.</h4>
                            }
                        </div>
                    </div>
                </div>
              </div>
            : <>
                {showList &&
                    <>
                        {people.length > 0
                        ?<PeopleList people={people} currentTab={currentTab} />
                        :<div className="page-card narrow light g5-text" >
                        {noPeopleMessage}
                        </div>
                        }
                    </>
                }
              </>
            }
        </div>
    )
}

const mapStateToProps = (state) => ({
    //auth: state.auth,
    //people: state.people.people
})


export default connect(mapStateToProps, { logout, getPeopleByProjects, getPeopleByProject, getPeopleByCompany, clearPeople, setActiveSidebarPage, getCompany, getCompanyInvites, sendCompanyInvite, revokeCompanyInvite})(People);